import {NgModule} from "@angular/core"
import {MaterialModule} from "app/common/material/MaterialModule"
import {ConfirmationService} from "app/common/services/confirmation/service/ConfirmationService"
import {ConfirmationDialogComponent} from "app/common/services/confirmation/dialog/ConfirmationDialogComponent"

@NgModule({
    declarations: [
        ConfirmationDialogComponent
    ],
    entryComponents: [
        ConfirmationDialogComponent
    ],
    providers: [
        ConfirmationService
    ],
    imports: [
        MaterialModule
    ]
})
export class ConfirmationServiceModule {

}
